export interface NextFlightPromptProps {
  nextName: string;
  onContinue: () => void;
  onDismiss: () => void;
}

export function NextFlightPrompt(
  { nextName, onContinue, onDismiss }: NextFlightPromptProps,
): JSX.Element {
  return (
    <div
      role="dialog"
      aria-label="Continue to next flight"
      style={{
        position: "absolute",
        right: 16,
        bottom: 72,
        zIndex: 1500,
        background: "#111",
        color: "#eee",
        border: "1px solid #333",
        borderRadius: 8,
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        gap: 12,
        boxShadow: "0 4px 16px rgba(0,0,0,.5)",
      }}
    >
      <span>{`Continue to ${nextName}?`}</span>
      <button
        type="button"
        onClick={onContinue}
        style={{
          background: "#2b6cb0",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          padding: "6px 14px",
          cursor: "pointer",
        }}
      >
        Continue
      </button>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={onDismiss}
        style={{
          background: "transparent",
          color: "#999",
          border: "none",
          fontSize: 16,
          cursor: "pointer",
        }}
      >
        &#10005;
      </button>
    </div>
  );
}
